import { Checkbox, Divider, FormControlLabel, Grid, Stack, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import React, { useState } from "react";
import SelectParticipants from "../SelectParticipants";

function Participants({ formData }) {
  const { values, setFieldValue } = formData;
  const { joinable: joinableV, users } = values.participants;
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);

  const handleParticipantsSelect = (selectedUsers) => {
    setFieldValue("participants.users", selectedUsers);
    setIsSelectionModalOpen(false);
  };

  return (
    <Grid container spacing={3} p={1}>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDBox>
              <MDTypography variant="h5" fontWeight="bold">
                Participants
              </MDTypography>
              <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                Who will compete?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2}>
              <MDBox
                sx={{
                  border: "1px solid #000",
                  borderRadius: "15px",
                  height: "220px",
                  p: 0.5,
                }}
              >
                <MDBox
                  sx={{
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    p: 1,
                  }}
                  className="user-list"
                >
                  {users
                    ?.sort((a, b) => (a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1))
                    ?.map((user, index) => (
                      <React.Fragment key={user.id}>
                        <MDTypography
                          variant="subtitle1"
                          sx={{ color: "#7b809a", fontSize: "1rem" }}
                        >
                          {user.name}
                        </MDTypography>
                        {index !== users.length - 1 && (
                          <Divider sx={{ my: 0.5, backgroundColor: "#000", mx: -1 }} />
                        )}
                      </React.Fragment>
                    ))}
                </MDBox>
              </MDBox>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <MDButton
                  sx={{ px: "0.65rem" }}
                  variant="outlined"
                  color="newColor"
                  type="button"
                  typeof="button"
                  onClick={() => setIsSelectionModalOpen(true)}
                >
                  Select Participants
                </MDButton>
                <MDTypography
                  variant="subtitle1"
                  sx={{ color: "#7b809a", fontSize: { xs: "0.9rem", sm: "1rem" } }}
                >
                  {users.length} {users.length > 1 ? "Participants" : "Participant"} Selected
                </MDTypography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={2}>
          <Grid item xs={12} display="flex" justifyContent={{ sm: "flex-end" }}>
            <MDBox>
              <MDTypography variant="h5" fontWeight="bold">
                Joinable
              </MDTypography>
              <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                Will competition be open for anyone to join?
              </MDTypography>
              <Switch
                sx={{ marginLeft: "-12px" }}
                size="medium"
                checked={joinableV}
                onChange={(_, checked) => {
                  setFieldValue("participants.joinable", checked);
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        display="flex"
        justifyContent="flex-end"
        sx={{
          "& .MuiFormControlLabel-root": {
            display: "flex",
            mr: 0,
          },
          "& .MuiTypography-root ": {
            fontSize: "1rem",
          },
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={values.addCompetitionAsFav}
              onChange={(_, checked) => setFieldValue("addCompetitionAsFav", checked)}
            />
          }
          label="Save To Favorites"
        />
      </Grid>

      <SelectParticipants
        open={isSelectionModalOpen}
        setOpen={setIsSelectionModalOpen}
        users={users}
        selectParticipants={handleParticipantsSelect}
        form
      />
    </Grid>
  );
}

export default Participants;
